$(document).on('click', '.page-item-back', changePageBack);
$(document).on('click', '.page-item-number', changePageNumber);
$(document).on('click', '.page-item-next', changePageNext);
$(document).on('change', '#search-input', function(){
  pagination.search = $(this).val();
  pagination.page = 1;
  getPagedBlogs();
});
var pagination = {
  page: 1,
  size: 5,
  total: 0,
  totalPages:0,
  search: ''
};
$(document).ready(function(){
  getPagedBlogs();
});
function getPagedBlogs(){
  $('#blogs-list').empty().append('<li class="blog-item blog-item-even"><i class="fas fa-spinner fa-spin d-block mx-auto loading-icon"></i></li>');
  let DataSend = {
    lang: lang,
    pagination: pagination
  }
  PostMethodFunction(erp_url+'api/blog/get-page', DataSend, null, showPagedBlogs, null);
}
function showPagedBlogs(response){
  //console.log('showPageBlogs => ', response);
  /*set meta tag keywords*/
  let metaKeywords = [];
  pagination = response.pagination;
  let AppenedContent = '';
  $.each(response.data, function(index, value){
    value.keywords = value.keywords.replace(/, /g, ',');
    value.keywords.split(',').forEach(function(keyword){
      if(!metaKeywords.includes(keyword)){
        metaKeywords.push(keyword);
      }
    });
    AppenedContent += '<li class="blog-item blog-item'+(index%2?'-odd':'-even')+'">';
      AppenedContent += '<img class="blog-img-item" src="'+value.image_path+'" alt="'+value.title+'">';
      AppenedContent += '<div class="blog-text-item">';
        AppenedContent += '<h3 class="blog-title">'+value.title+'</h3>';
        AppenedContent += '<p class="blog-brief">'+value.brief+'</p>';
        AppenedContent += '<button class="view-more-button" onclick="location.href=\'/blogs/view/'+value.url+'\'">'+(lang=='en'?'Learn More':'Leer Más')+'</button>';
      AppenedContent += '</div>';
    AppenedContent += '</li>';
  });
  $('#blogs-list').empty().append(AppenedContent);
  /*set meta tag keywords*/
  $('meta[name=keywords]').attr('content', metaKeywords.join(', '));
  refreshPagination();
}
function changePageBack(){
  if(pagination.page > 1){
      pagination.page = parseInt(pagination.page) - 1;
      getPagedBlogs();
  }
}
function changePageNumber(){
  let selectedPage = $(this).find('p').text();
  if(selectedPage == pagination.page) return;
  pagination.page = selectedPage;
  getPagedBlogs();
}
function changePageNext(){
  if(pagination.page < pagination.totalPages){
      pagination.page = parseInt(pagination.page) + 1;
      getPagedBlogs();
  }
}
function refreshPagination(){
  let paginationContainer = $('.pagination-list');
  paginationContainer.empty();
  if(pagination.totalPages > 1){
      let AppenedContent = '';
      AppenedContent += '<li class="page-item page-item-back"><p class="page-link"><<</p></li>';
      for (let index = 1; index <= pagination.totalPages; index++) {
          AppenedContent += '<li class="page-item page-item-number"><p class="page-link'+(index==pagination.page?' active':'')+'">'+index+'</p></li>';
      }
      AppenedContent += '<li class="page-item page-item-next"><p class="page-link">>></p></li>';
      paginationContainer.append(AppenedContent);
  }
}